module.exports = __webpack_public_path__ + "img/category-popular.df69dcc3.png";